import { useParams } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';
import { useFeatureSubscription_CancelStripeSubscriptionLazyQuery } from 'queries';

import { NotificationSeverity, showAlert, showToast } from 'utils/notification-manager';

type Props = {
  setShowModal: (value: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onCancelSubscriptionComplete: Function;
};

export default function CancelSubscriptionConfirmation({
  setShowModal,
  onCancelSubscriptionComplete,
}: Props) {
  const { portalId } = useParams<Record<string, string>>();

  const [cancelSubscription] = useFeatureSubscription_CancelStripeSubscriptionLazyQuery({
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      showToast({
        message: 'Your subscription has been cancelled.',
        severity: NotificationSeverity.SUCCESS,
      });
      onCancelSubscriptionComplete();
      setShowModal(false);
    },
    onError: (e) => {
      showAlert({
        message: 'Error cancelling subscription: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
      setShowModal(false);
    },
  });

  const handleYesOnConfirmation = () => {
    cancelSubscription({
      variables: {
        portalId: portalId,
      },
    });
  };
  const handleNoOnConfirmation = () => {
    setShowModal(false);
  };

  return (
    <>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item>
          <Typography variant="h5">
            Are you sure you would like to cancel your subscription?
          </Typography>
          <Typography variant="subtitle2">
            You can continue to use the Trustate app until the end of your billing cycle.
          </Typography>
        </Grid>
        <Grid item>
          <Button
            component="span"
            color="primary"
            variant="contained"
            size="small"
            onClick={handleNoOnConfirmation}
          >
            No
          </Button>
        </Grid>
        <Grid item>
          <Button
            component="span"
            color="secondary"
            variant="contained"
            size="small"
            onClick={handleYesOnConfirmation}
          >
            Yes
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
